// Shared helpers for the AI Dialer pages. Kept pure + framework-free so
// tests can lock down the selection logic without React in the loop.

const VALID_PRIMARY_STATUSES = new Set(['ready', 'draft', 'active']);

// Pick the "primary" AI screener bot for the current tenant.
//
//   - Excludes soft-deleted bots (`deletedAt` set)
//   - Restricts to statuses that match what the Screeners tab surfaces
//     (ready / draft / active) so we never auto-pick an archived bot
//   - 1 bot → that one
//   - >1   → most-recently-updated wins (sort by `updatedAt` desc)
//   - 0    → returns null (callers fall back to the stock Adam persona)
export function primaryBot(bots) {
  if (!Array.isArray(bots) || bots.length === 0) return null;
  const eligible = bots.filter((b) => {
    if (!b || b.deletedAt) return false;
    if (b.status && !VALID_PRIMARY_STATUSES.has(b.status)) return false;
    return true;
  });
  if (eligible.length === 0) return null;
  if (eligible.length === 1) return eligible[0];
  const ts = (b) => {
    const t = b?.updatedAt ? Date.parse(b.updatedAt) : 0;
    return Number.isNaN(t) ? 0 : t;
  };
  return [...eligible].sort((a, b) => ts(b) - ts(a))[0];
}
